import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import BrandCard from "@/components/BrandCard";
import { Button } from "@/components/ui/button";
import { ACTIVE_BRANDS } from "@/data/catalog";
import { fetchProducts } from "@/lib/api";

export default function Brands() {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    fetchProducts()
      .then((list) => {
        const m = {};
        list.forEach((p) => (m[p.brandSlug] = (m[p.brandSlug] || 0) + 1));
        setCounts(m);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
      <Seo title="HVAC Brands | CA HVAC Direct" description="Shop HVAC equipment by brand at CA HVAC Direct — Midea, Goodman, Daikin, TOSOT, TCL and Aspen." path="/brands" />
      <span className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-sky-700">Manufacturers</span>
      <h1 className="mt-2 font-heading text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">Shop by Brand</h1>
      <p className="mt-3 max-w-2xl text-slate-600">We carry equipment from established HVAC manufacturers. Select a brand to filter the catalog.</p>
      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {ACTIVE_BRANDS.map((b) => <BrandCard key={b.slug} brand={b} count={counts[b.slug] ?? null} />)}
      </div>
      <div className="mt-10">
        <Button asChild className="rounded-sm bg-sky-700 hover:bg-sky-800"><Link to="/shop">Browse all equipment <ArrowRight className="h-4 w-4" /></Link></Button>
      </div>
    </div>
  );
}
